//Custom event to listen when the ajax call is made, then we need to check if
//there is any certification tree/checkbox tree
const searchRequestListener = jQuery.Event('searchRequestListener');

document.addEventListener('searchRequestListener', function () {

    searchParams.setQuery($('.textSearch input[type="search"]').val());
    searchParams.setFilter($.urlParam('filters') || '');
    searchParams.setPage($.urlParam('page') || 1);
    searchParams.setPath($.urlParam('paths[]'));

    let certs = $('.certification_filter_list :checkbox');

    // Certification filters
    if (certs.eq(0).is(':checked') || $.urlParam('certification2')) {
        searchParams.setCertification2(true);
    } else {
        searchParams.setCertification2(null);
    }
    if (certs.eq(1).is(':checked') || $.urlParam('certification3')) {
        searchParams.setCertification3(true);
    } else {
        searchParams.setCertification3(null);
    }

    let sorting_select = $('#SortSelect').val();

    if (sorting_select !== '' && sorting_select !== undefined) {
        if (sorting_select.indexOf('dist') !== -1) {
            // GEO Location
            let mainObj = {
                lat: locationService.get('lat'),
                lon: locationService.get('lng')
            };

            searchParams.setGeo(mainObj);
        }

        let sorting_info = sorting_select.split(':'),
            order_by_field = sorting_info[0],
            order = {};

        order[order_by_field] = sorting_info[1];

        searchParams.setOrder(order);
        persistUrl({order: order});

    }
});

$('form.search-form.prevent-submit').submit(function (e) {
    e.preventDefault();
    searchParams.setPage(1);
    _initGETResults();
    persistUrl({page: 1});
    // triggerSearch();
});

$('#rightCol').on('change', ':checkbox', function () {
    searchParams.setPage(1);
    persistUrl({page: 1});
    if ($('.ratingList').data('useUrlParams')) {
        getTop5({
                fag_filter: searchParams.getFilterUrlParams().filters,
                paths: searchParams.getFilterUrlParams()['paths[]']
            }
        );
        // $('.ratingList .listHeader h4 strong').html(searchParams.getFirstSingularSearch(' ditt søkomrade'));
    } else {
        getTop5();
    }
});

$('.certification_filter_list').on('change', ':checkbox', function () {
    let certObj = {};

    if (!$(this).is(':checked')) {

        if ($(this).attr('name') === 'certification1') {
            searchParams.setCertification1('');
        } else if ($(this).attr('name') === 'certification2') {
            searchParams.setCertification2('');
        } else if ($(this).attr('name') === 'certification3') {
            searchParams.setCertification3('');
        }

        certObj[$(this).attr('name')] = '';
        persistUrl(certObj);

    } else {
        if ($(this).attr('name') === 'certification1') {
            searchParams.setCertification1(true);
        } else if ($(this).attr('name') === 'certification2') {
            searchParams.setCertification2(true);
        } else if ($(this).attr('name') === 'certification3') {
            searchParams.setCertification3(true);
        }

        certObj[$(this).attr('name')] = true;
        persistUrl(certObj);
    }
    searchParams.setPage(1);
    persistUrl({page: 1});
    triggerSearch();
});

$('.search-results-page .filterList .fag_filter_list').on('change', ':checkbox', function () {
    if (!$(this).is(':checked')) {
        searchParams.removeFilter($(this).val());
        persistUrl({'filters': ''});
    } else {
        searchParams.setFilter($(this).val());
        persistUrl({'filters': $(this).val()});
    }
    searchParams.setPage(1);
    persistUrl({page: 1});
    triggerSearch();
});

let $filterList = $('.search-results-page .filterList');

let c = null;

$filterList.on('change', 'li input:checkbox', function () {

    let path = $(this).data('path'),
        paths = searchParams.getFilterUrlParams()['paths[]'];

    c = $(this);

    if (!$(this).is(':checked')) {

        let idx = paths.indexOf(path);
        if (idx >= 0) {
            paths.splice(idx, 1);
        }

        $.each($(this).parents('li').first().find('input:checkbox'), function (i, d) {
            d.checked = false;
            let idx = paths.indexOf(d.dataset.path);
            if (idx >= 0) {
                paths.splice(idx, 1);
            }
        });

        searchParams.setPath(paths);
        persistUrl({'paths[]': paths});
    } else {
        paths.push(path);
        searchParams.setPath(paths);
        persistUrl({'paths[]': paths});
    }

    searchParams.setPage(1);
    persistUrl({page: 1});
    triggerSearch();
});

$('.pagination').on('click', 'a', function () {
    $('#subPageContent').find('.loading').fadeIn();

    GETParams = GETParams || {};

    GETParams.page = $(this).data('target-page') || '';

    window.history.pushState(GETParams, window.title, '?' + $.param(GETParams).replace(/\+/g, '%20'));
    searchParams.setPage($(this).attr('data-target-page'));
    searchParams.doSearch().done(function (response) {
        buildResponse(response);
    }).always(function () {
        $('#subPageContent').find('.loading').fadeOut();
    });
});

$('.omrader_filter_list').on('change.hide_show_children', ':checkbox', function () {
    $(this).parents('li:first')[$(this).is(':checked') ? 'addClass' : 'removeClass']('checked');
    if (!$(this).is(':checked')) {
        $(this).parents('li:first').find('ul :checkbox').removeAttr('checked');
    }
});

$('#SortSelect').change(function () {
    let sorting = $(this).val();
    if (sorting.indexOf('dist') !== -1) {
        // GEO Location
        let mainObj = {
            lat: locationService.get('lat'),
            lon: locationService.get('lng')
        };

        searchParams.setGeo(mainObj);
    }
    let sorting_info = sorting.split(':'),
        order_by_field = sorting_info[0],
        order = {};

    order[' " ' + order_by_field + ' " '] = sorting_info[1];

    searchParams.setOrder(order);
    persistUrl({order: order});


    triggerSearch(function (ajax_response) {
        /** @namespace ajax_response.result.hits */
        let total_results = ajax_response.result.hits.total;
        $('.searchResultList .filterBtns').show()
            .find('strong').text(total_results + ' bedrift' + ((total_results !== 1) ? 'er' : ''));
    });
});

/*
$('.searchBoxLink input[name="yourArea"]').not('.home-page').on('change.update-location', function () {
    if ($(this).is(":checked")) {
        persistUrl({
            'areas[]': locationService.getArea(),
            'places[]': locationService.getPlace(),
            'citypart[]': locationService.getCitypart()
        });
    } else {
        persistUrl({'areas[]': '', 'places[]': '', 'citypart[]': ''});
    }
});
*/

$('input[type="search"].is-search-input').on('change.persistent-urls', function () {
    persistUrl({q: $(this).val()});
});

$('.logout').on('click', function (e) {
    e.preventDefault();
    userController.logout().always(() => {
        if (/min-side/.test(window.location.pathname)) {
            window.location.replace("/@min-side/login");
        } else {
            window.location.reload();
        }

    });
});